<!-- <dashboardnav> -->
    <cradua-assetstatus
    [assetStatuss]="assetStatuss$ | async"
    (assetStatus)="onSubmitAssetStatus($event)"
    (deleteAssetStatusEvent)="onDeleteAssetStatus($event)"
    *ngIf="(isLoadingAssetStatus$ | async ) === false"
    >
  </cradua-assetstatus>

    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoadingAssetStatus$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  <!-- </dashboardnav> -->
